import { useEffect, useState } from 'react'

// Returns `value` after it's been stable for `delayMs` ms. Used by the
// tag-search inputs in TagsPage + PlantPage/TagProviderBrowser to
// throttle filter queries while a user is still typing.
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value)
  useEffect(() => {
    const id = window.setTimeout(() => setDebounced(value), delayMs)
    return () => window.clearTimeout(id)
  }, [value, delayMs])
  return debounced
}
